import { Injectable } from '@angular/core';
import { isUndefinedOrNull, isUndefinedOrNullOrEmpty } from '../util';

@Injectable({
  providedIn: 'root'
})
export class MandatoryImagesService {
  /**
   * Checks if all required images are present in the provided array and each has a non-empty URL.
   *
   * @param detailedImage Array of image objects with id and url.
   * @param requiredIds Optional array of required image ids (defaults to [1,3,5,8,10,11]).
   * @returns True if all required images are present and have a non-empty url, false otherwise.
   */
  public checkMandatoryImages(
    detailedImage: Array<{ id: number | string; url?: string }> | undefined | null,
    requiredIds: number[] = [1, 3, 5, 8, 10, 11]
  ): boolean {
    if (isUndefinedOrNull(detailedImage) || !Array.isArray(detailedImage)) {
      return false;
    }
    let image: { id: number | string; url?: string } | undefined;
    for (const id of requiredIds) {
      image = detailedImage.find(
        (img: { id: number | string; url?: string }): boolean => Number(img.id) === id
      );
      if (
        isUndefinedOrNull(image) ||
        isUndefinedOrNullOrEmpty(image?.url)
      ) {
        return false;
      }
    }
    return true;
  }
}
